import { QrCodeProps } from './QrCode.types.ts';

export default function QrCode(props: QrCodeProps) {
  return (
    <img
      src={props.qr_code}
      alt="Placeholder"
      className="ConnectionModal__Artboard__Image"
    />
  );
}
